export default class File {
  constructor(id = null, file = '', type = '') {
    this.id = id;
    this.file = file;
    this.type = type;
  }
}
